import React, { useState, useEffect } from "react";
import "./ResetPassword.css";
import logo from "../images/download.svg";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabase";
import image1 from "../images/dark-green-pickleball-court.jpg";
import image2 from "../images/padel-court.jpg";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const slideshowImages = [image1, image2];

const ResetPassword = () => {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [titlePrefix, setTitlePrefix] = useState("Pickle");
  const [scrollDirection, setScrollDirection] = useState("down");

  // Auto-cycle the slideshow every 5 seconds, skipping the first immediate execution
  useEffect(() => {
    let isFirstRun = true;

    const interval = setInterval(() => {
      if (isFirstRun) {
        isFirstRun = false;
        return; // Skip the first execution
      }

      setCurrentSlide((prevSlide) => (prevSlide + 1) % slideshowImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slideshowImages.length]);

  // Sync titlePrefix and scrollDirection with the current slide
  useEffect(() => {
    const newTitlePrefix = currentSlide === 0 ? "Pickle" : "Padel";
    const newDirection = currentSlide === 0 ? "down" : "up";
    setTitlePrefix(newTitlePrefix);
    setScrollDirection(newDirection);
  }, [currentSlide]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const { error } = await supabase.auth.updateUser({
        password: newPassword,
      });

      if (error) {
        console.error("Error updating password:", error);
        setError(`Failed to update password: ${error.message}`);
        return;
      }

      setSuccess(
        "Password updated successfully! You can now log in with your new password."
      );
      setTimeout(() => navigate("/login"), 3000); // Redirect to login after 3 seconds
    } catch (error) {
      console.error("Unexpected error during password update:", error);
      setError("An unexpected error occurred. Please try again.");
    }
  };

  const handleLogoClick = () => {
    // //console.log("ResetPassword.js: handleLogoClick called");
    const defaultState = {
      selectedBookingType: "Bookings",
      selectedProfile: false,
      selectedSport: null,
      selectedDate: null,
      selectedCourtType: null,
      selectedCourt: null,
      selectedTimeslots: [],
    };
    // //console.log("ResetPassword.js: Navigating to / with state:", defaultState);
    navigate("/", { state: defaultState });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="reset-password-page-container reset-password-page">
      {/* Left Section (Slideshow) */}
      <div className="reset-password-left-section">
        <div className="slideshow">
          {slideshowImages.map((image, index) => (
            <div
              key={index}
              className={`slide ${index === currentSlide ? "active" : ""}`}
              style={{
                backgroundImage: `url(${
                  typeof image === "string" ? image : image.default
                })`,
              }}
            ></div>
          ))}
        </div>
      </div>

      {/* Right Section (Form Area) */}
      <div className="reset-password-right-section">
        <div
          className="logo-container"
          onClick={handleLogoClick}
          style={{ cursor: "pointer" }}
        >
          <img
            src={logo}
            alt="PickleDepot/PadelDepot Logo"
            className="reset-password-logo"
          />
        </div>
        <div className="title-wrapper">
          <div className="title-container">
            <h2 className="reset-password-title">
              <span className="title-prefix-wrapper">
                <span className={`title-prefix ${scrollDirection}`}>
                  <span className="title-prefix-item">Pickle</span>
                  <span className="title-prefix-item">Padel</span>
                  <span className="title-prefix-item">Pickle</span>
                </span>
              </span>
              <span className="title-suffix">Depot</span>
            </h2>
          </div>
        </div>
        {error && <p className="reset-password-error">{error}</p>}
        {success && <p className="reset-password-success">{success}</p>}
        <form className="reset-password-form" onSubmit={handleSubmit}>
          <div className="reset-password-form-group">
            <label htmlFor="new-password">New Password</label>
            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                id="new-password"
                className="reset-password-input"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                placeholder="Enter your new password"
              />
              <span
                className="password-toggle"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>
          <button
            type="submit"
            className="reset-password-button"
            aria-label="Update password"
          >
            Update Password
          </button>
        </form>
        <p className="reset-password-login-link">
          Return to{" "}
          <a href="/login" className="reset-password-link">
            Login
          </a>
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;
